import { getLoaders } from 'entities/_config';

import { apiCall } from 'services/api';
import { AuthTokens, LoginSuccess } from './types';

let refreshInFlight: Promise<AuthTokens> | null = null;

export const authLoaders = getLoaders({
  loginWithCode: {
    load: async (payload: { code: string }): Promise<LoginSuccess> => {
      return apiCall({
        path: '/auth/login-code/exchange',
        payload,
        auth: false,
        withCookies: true,
      });
    },
  },

  refreshSession: {
    load: async (payload: { refreshToken: string }): Promise<AuthTokens> => {
      if (refreshInFlight) return refreshInFlight;

      refreshInFlight = apiCall<AuthTokens>({
        path: '/auth/refresh',
        payload,
        auth: false,
      }).finally(() => {
        // Clear after settle so future calls can trigger a new refresh.
        refreshInFlight = null;
      });

      return refreshInFlight;
    },
  },

  validatePasswordToken: {
    load: async (payload: { token: string }): Promise<{ isValid: boolean }> => {
      return apiCall({
        path: '/auth/password/recover/validate',
        payload,
        auth: false,
      });
    },
  },
});
